export default {
  tournaments (state) {
    return {
      ...state,
      storeName: 'tournaments'
    }
  }
}
